module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-12 px-0 mx-0"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "latitude"
    }
  }, [_vm._v("Latitude")]), _vm._v(" "), _c('input', {
    ref: "latitude",
    staticClass: "form-control",
    class: {
      'input form-control': true, 'is-invalid form-control': _vm.hasLatError
    },
    domProps: {
      "value": _vm.latitude
    },
    on: {
      "input": function($event) {
        _vm.updateMap()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasLatError),
      expression: "hasLatError"
    }],
    staticClass: "help is-invalid"
  }, [_vm._v("You've entered an invalid latitude.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 px-0 mx-0"
  }, [_c('label', {
    attrs: {
      "for": "longitude"
    }
  }, [_vm._v("Longitude")]), _vm._v(" "), _c('input', {
    ref: "longitude",
    staticClass: "form-control",
    class: {
      'input form-control': true, 'is-invalid form-control': _vm.hasLongError
    },
    domProps: {
      "value": _vm.longitude
    },
    on: {
      "input": function($event) {
        _vm.updateMap()
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasLongError),
      expression: "hasLongError"
    }],
    staticClass: "help is-invalid"
  }, [_vm._v("You've entered an invalid longitude.")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 py-0 mx-0"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-arrows",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Drag the blue dot to adjust the latitude and longitude")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-2",
    attrs: {
      "id": "map-edit-loc-2"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4b8a0d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/widgets/mapbox-latlong-2.vue
// module id = 568
// module chunks = 1